import React from "react";
import TestQues from "../../testQues/testQues";
import "./listenSpeak.scss";

// const reducer = (state, action) => {
//   switch (action.type) {
//     case "":
//       return;

//     default:
//       return;
//   }
// };
export default function ListenSpeak({ question, questions, index }) {
  return (
    <div
      data-aos="zoom-in"
      className="test-body-content"
      style={{
        justifyContent:
          question.test_format === "listen_speak_fluency"
            ? "initial"
            : "center",
      }}
    >
      <TestQues type="listenSpeak" question={question} />
    </div>
  );
}
